window.productCarouselModule = (() => {
  if (!customElements.get("product-carousel")) {
    customElements.define(
      "product-carousel",
      class ProductCarouselComponent extends HTMLElement {
        constructor() {
          super();
          this.initializedNosto = false;
          this.initializedNosto = false;
          document.addEventListener("DOMContentLoaded", () => {
            this.init();
          });
        }

        init() {
          window.productCarouselSwiperInit = false;
          this.observeTargetDiv();
          this.initializeSwiper();
        }

        observeTargetDiv() {
          const targetDiv = this.querySelector(".js-product-carousel");

          if (!targetDiv) return;

          const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
              if (
                mutation.type === "childList" &&
                targetDiv.querySelector(".nosto_element.nosto-dynamic-placement") &&
                !this.initializedNosto
              ) {
                this.initializedNosto = true;
                console.log("INITIALIZED");
                this.initializeSwiper();
              }
            });
          });

          observer.observe(targetDiv, { childList: true, subtree: true });
        }

        initializeSwiper() {
          // Generate unique class names for the Swiper instance and navigation buttons
          const uniqueSwiper = this.querySelector(".js-product-carousel").id;
          const uniqueNext = this.querySelector(".js-product-carousel-next").id;
          const uniquePrev = this.querySelector(".js-product-carousel-prev").id;

          // Initialize Swiper with the unique class names
          this.carouselSwiper = new Swiper(`#${uniqueSwiper}`, {
            slidesPerView: 1.6,
            slidesPerGroup: 2,
            spaceBetween: 12,
            freeMode: true,
            breakpoints: {
              475: {
                spaceBetween: 24,
                slidesPerView: 3,
                slidesPerGroup: 3,
                freeMode: false,
                navigation: {
                  nextEl: `#${uniqueNext}`,
                  prevEl: `#${uniquePrev}`,
                },
              },
              1024: {
                spaceBetween: 48,
                slidesPerView: 3.8,
                slidesPerGroup: 4,
                freeMode: false,
                navigation: {
                  nextEl: `#${uniqueNext}`,
                  prevEl: `#${uniquePrev}`,
                },
              },
            },
          });

          this.handleFadeOuts();
        }

        handleFadeOuts() {
          const leftFadeOuts = Array.from(this.querySelectorAll(".js-generic__fade-out__product-carousel--left"));
          const rightFadeOuts = Array.from(this.querySelectorAll(".js-generic__fade-out__product-carousel--right"));

          leftFadeOuts.forEach((leftFadeOut, i) => {
            this.carouselSwiper.on("progress", (swiper, progress) => {
              this.updateFadeOutVisibility(progress, leftFadeOut, rightFadeOuts[i]);
            });
          });
        }

        updateFadeOutVisibility(progress, leftFadeOut, rightFadeOut) {
          if (progress === 0) {
            leftFadeOut.classList.add("opacity-0");
            rightFadeOut.classList.remove("opacity-0");
          } else if (progress === 1) {
            rightFadeOut.classList.add("opacity-0");
            leftFadeOut.classList.remove("opacity-0");
          } else {
            leftFadeOut.classList.remove("opacity-0");
            rightFadeOut.classList.remove("opacity-0");
          }
        }
      }
    );
  }
})();
